import { useState, useEffect } from "react";
import { useAuth } from "../auth";
import api from "../api";
import Modal from "../components/Modal";

/* ── Action icon button ─────────────────────────────────────────── */
function Btn({title, color="#e2e8f0", textColor="#64748b", onClick, children}){
  return(
    <button title={title} onClick={onClick}
      style={{background:color,color:textColor,border:"none",borderRadius:8,
        width:32,height:32,cursor:"pointer",fontSize:15,display:"inline-flex",
        alignItems:"center",justifyContent:"center",transition:"opacity .15s"}}
      onMouseEnter={e=>e.currentTarget.style.opacity=".75"}
      onMouseLeave={e=>e.currentTarget.style.opacity="1"}>
      {children}
    </button>
  );
}

/* ── Users Tab ──────────────────────────────────────────────────── */
function UsersTab(){
  const { impersonate } = useAuth();
  const [users,  setUsers]  = useState([]);
  const [search, setSearch] = useState("");
  const [modal,  setModal]  = useState(false);
  const [depts,  setDepts]  = useState([]);
  const [desigs, setDesigs] = useState([]);
  const [form,   setForm]   = useState({employee_id:"",first_name:"",last_name:"",
    email:"",role:"team_member",department_id:"",designation:"",mobile:"",
    date_of_joining:"",reporting_to_name:""});
  const [photo,  setPhoto]  = useState(null);
  const [msg,    setMsg]    = useState("");

  const [license, setLicense] = useState(null);
  const load = () => api.get("/portal/admin/users").then(d=>{
    setUsers(d.users||[]);
    setLicense({used:d.seats_used, max:d.seats_max, left:d.seats_left, full:d.seats_full});
  });
  useEffect(()=>{
    load();
    api.get("/portal/departments").then(d=>setDepts(d.departments||[]));
    api.get("/portal/designations").then(d=>setDesigs(d.designations||[]));
  },[]);

  const ROLE_MAP={admin:"Admin",hr:"HR",team_member:"Team Member",manager:"Manager"};

  const filtered = users.filter(u =>
    `${u.name} ${u.employee_id} ${u.email} ${u.role}`.toLowerCase().includes(search.toLowerCase())
  );

  const resetForm = () => {
    setForm({employee_id:"",first_name:"",last_name:"",email:"",role:"team_member",
      department_id:"",designation:"",mobile:"",date_of_joining:"",reporting_to_name:""});
    setPhoto(null); setMsg("");
  };

  const openModal = () => { resetForm(); setModal(true); };

  const submit = async () => {
    if (!form.employee_id.trim())  { setMsg("Employee ID is required."); return; }
    if (!form.first_name.trim())   { setMsg("First Name is required."); return; }
    if (!form.last_name.trim())    { setMsg("Last Name is required."); return; }
    if (!form.email.trim())        { setMsg("Email is required."); return; }
    if (!form.designation.trim())  { setMsg("Designation is required."); return; }
    if (!form.department_id)       { setMsg("Department is required."); return; }
    if (!form.date_of_joining)     { setMsg("Date of Joining is required."); return; }
    setMsg("Creating…");
    try {
      await api.post("/portal/admin/users", {
        employee_id: form.employee_id.trim().toUpperCase(),
        first_name: form.first_name, last_name: form.last_name,
        email: form.email, role: form.role,
        department_id: form.department_id ? parseInt(form.department_id) : null,
      });
      // Update full fields
      await api.patch(`/portal/employees/${form.employee_id.toUpperCase()}`, {
        first_name: form.first_name, last_name: form.last_name, email: form.email,
        mobile: form.mobile, designation: form.designation,
        department_id: form.department_id ? parseInt(form.department_id) : null,
        date_of_joining: form.date_of_joining,
        reporting_to_name: form.reporting_to_name,
        role: form.role, gender:"", location:"",
      });
      // Upload photo if chosen
      if (photo) {
        setMsg("Uploading photo…");
        const fd = new FormData(); fd.append("photo", photo); fd.append("force","true");
        const res = await fetch(`/api/portal/employees/${form.employee_id.toUpperCase()}/photo`, {
          method:"POST",
          headers:{Authorization:`Bearer ${sessionStorage.getItem("iws_token")}`},
          body: fd,
        });
        const r = await res.json();
        setMsg(r.ok ? "✓ Added & face enrolled!" : `✓ Added. Face: ${r.reason||"not detected"}`);
      } else {
        setMsg("✓ Employee added.");
      }
      load();
      setTimeout(()=>{ setModal(false); resetForm(); }, 2000);
    } catch(e){ setMsg(e.message); }
  };

  const toggleActive = async (u) => {
    if (!confirm(`${u.is_active?"Disable":"Enable"} ${u.name}?`)) return;
    await api.patch(`/portal/admin/users/${u.employee_id}`,{is_active:!u.is_active});
    load();
  };

  const resetPw = async (u) => {
    if (!confirm(`Reset ${u.name}'s password to their Employee ID?`)) return;
    try {
      const res = await api.post(`/portal/admin/users/${u.employee_id}/reset_password`, {});
      alert(res.message || "Password reset.");
    } catch(e){ alert(e.message); }
  };

  const deleteEmp = async (u) => {
    if (!confirm(`Permanently delete ${u.name} (${u.employee_id})? This cannot be undone.`)) return;
    try {
      await api.patch(`/portal/admin/users/${u.employee_id}`,{is_active:false});
      setMsg(`${u.name} deactivated.`);
      load();
    } catch(e){ alert(e.message); }
  };

  const empPhotoUpload = async (u) => {
    const input = document.createElement("input");
    input.type="file"; input.accept="image/*";
    input.onchange = async () => {
      const fd = new FormData(); fd.append("photo", input.files[0]); fd.append("force","true");
      const res = await fetch(`/api/portal/employees/${u.employee_id}/photo`, {
        method:"POST",
        headers:{Authorization:`Bearer ${sessionStorage.getItem("iws_token")}`},
        body: fd,
      });
      const r = await res.json();
      alert(r.ok ? `✓ Face enrolled for ${u.name}!` : `Photo saved. Face: ${r.reason||"not detected"}`);
      load();
    };
    input.click();
  };

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <h3 style={{fontWeight:700,fontSize:13,textTransform:"uppercase",letterSpacing:".06em",color:"var(--muted)",margin:0}}>
          Employees <span style={{color:"var(--accent)",fontWeight:400}}>({filtered.length})</span>
        </h3>
        <button className="btn" onClick={license?.full?null:openModal}
          disabled={license?.full}
          title={license?.full?"All licenses used. Contact support to add more.":""}
          style={{opacity:license?.full?0.5:1,cursor:license?.full?"not-allowed":"pointer"}}>
          {license?.full?"🔴 Licenses Full":"+ Add Employee"}
        </button>
      </div>
      {/* License usage banner */}
      {license&&(
        <div style={{marginBottom:16,padding:"12px 18px",borderRadius:10,
          background:license.full?"#FEE2E2":license.left<=2?"#FEF3C7":"#F0FDF4",
          border:`1px solid ${license.full?"#FCA5A5":license.left<=2?"#FCD34D":"#86EFAC"}`,
          display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <div style={{fontSize:22,fontWeight:800,
              color:license.full?"#DC2626":license.left<=2?"#D97706":"#16A34A"}}>
              {license.used} <span style={{fontSize:14,fontWeight:400,color:"#64748B"}}>/ {license.max} licenses used</span>
            </div>
            <div style={{display:"flex",gap:3}}>
              {Array(license.max).fill(0).map((_,i)=>(
                <div key={i} style={{width:10,height:10,borderRadius:2,
                  background:i<license.used?"#0D9488":"#E2E8F0"}}/>
              ))}
            </div>
          </div>
          {license.full?(
            <div style={{fontSize:13,color:"#991B1B",fontWeight:500}}>
              🔴 All licenses used — <b>contact us to upgrade:</b>
              <a href="mailto:hello@invincibleweb.in" style={{color:"#DC2626",marginLeft:6}}>hello@invincibleweb.in</a>
              <span style={{margin:"0 6px",color:"#94A3B8"}}>·</span>
              <a href="tel:+919211201003" style={{color:"#DC2626"}}>+91 92112 01003</a>
            </div>
          ):(
            <div style={{fontSize:13,color:license.left<=2?"#92400e":"#166534"}}>
              {license.left} license{license.left!==1?"s":""} remaining
            </div>
          )}
        </div>
      )}
      <input className="inp" style={{maxWidth:340,marginBottom:16}} value={search}
        onChange={e=>setSearch(e.target.value)} placeholder="Search name / email / ID / role…"/>
      <table className="tbl">
        <thead><tr>
          <th>ID</th><th>Name / Email</th><th>Role</th><th>Status</th>
          <th style={{textAlign:"right",paddingRight:8}}>{users.length} users</th>
        </tr></thead>
        <tbody>
          {filtered.map(u=>(
            <tr key={u.employee_id}>
              <td style={{color:"var(--muted)",fontSize:12,fontWeight:600}}>{u.employee_id}</td>
              <td>
                <b style={{fontSize:14}}>{u.name}</b><br/>
                <span style={{fontSize:12,color:"var(--muted)"}}>{u.email}</span>
              </td>
              <td>
                <select className="inp" style={{width:"auto",padding:"4px 8px",fontSize:12}}
                  value={u.role}
                  onChange={async e=>{
                    await api.patch(`/portal/admin/users/${u.employee_id}`,{role:e.target.value});
                    load();
                  }}>
                  {Object.entries(ROLE_MAP).map(([v,l])=><option key={v} value={v}>{l}</option>)}
                </select>
              </td>
              <td>
                <span className={`pill ${u.is_active?"green":"red"}`} style={{marginRight:4}}>
                  {u.is_active?"Active":"Inactive"}
                </span>
                <span className={`pill ${u.face_enrolled?"green":"gray"}`} style={{fontSize:10}}>
                  {u.face_enrolled?"✓ Face":"No face"}
                </span>
              </td>
              <td>
                <div style={{display:"flex",gap:5,justifyContent:"flex-end"}}>
                  <Btn title="Upload photo" color="#DBEAFE" textColor="#1D4ED8"
                    onClick={()=>empPhotoUpload(u)}>📷</Btn>
                  <Btn title={u.is_active?"Disable":"Enable"}
                    color={u.is_active?"#FEF3C7":"#DCFCE7"}
                    textColor={u.is_active?"#92400E":"#166534"}
                    onClick={()=>toggleActive(u)}>
                    {u.is_active?"⊘":"✓"}
                  </Btn>
                  <Btn title="Reset password" color="#FEF9C3" textColor="#854D0E"
                    onClick={()=>resetPw(u)}>🔑</Btn>
                  <Btn title="View as" color="#F1F5F9" textColor="#475569"
                    onClick={()=>impersonate(u.employee_id)}>👁</Btn>
                  <Btn title="Delete" color="#FEE2E2" textColor="#DC2626"
                    onClick={()=>deleteEmp(u)}>🗑</Btn>
                </div>
              </td>
            </tr>
          ))}
          {!filtered.length&&<tr><td colSpan={5} style={{textAlign:"center",color:"var(--muted)"}}>No employees.</td></tr>}
        </tbody>
      </table>

      {/* Add Employee Modal */}
      {modal&&(
        <Modal title="Add New Employee" onClose={()=>{ setModal(false); resetForm(); }}>
          <div style={{display:"grid",gap:14}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div>
                <label>Employee ID *</label>
                <input className="inp" value={form.employee_id} placeholder="e.g. IWS003"
                  onChange={e=>setForm({...form,employee_id:e.target.value.toUpperCase()})}/>
              </div>
              <div>
                <label>Role</label>
                <select className="inp" value={form.role} onChange={e=>setForm({...form,role:e.target.value})}>
                  {Object.entries(ROLE_MAP).map(([v,l])=><option key={v} value={v}>{l}</option>)}
                </select>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div><label>First Name <span style={{color:"#DC2626"}}>*</span></label>
                <input className="inp" value={form.first_name} placeholder="First name"
                  onChange={e=>setForm({...form,first_name:e.target.value})}/></div>
              <div><label>Last Name <span style={{color:"#DC2626"}}>*</span></label>
                <input className="inp" value={form.last_name} placeholder="Last name"
                  onChange={e=>setForm({...form,last_name:e.target.value})}/></div>
            </div>
            <div>
              <label>Email <span style={{color:"#DC2626"}}>*</span></label>
              <input className="inp" type="email" value={form.email} placeholder="email@company.com"
                onChange={e=>setForm({...form,email:e.target.value})}/>
            </div>
            <div>
              <label>Personal Email (optional)</label>
              <input className="inp" type="email" value={form.personal_email||""} placeholder="personal@gmail.com"
                onChange={e=>setForm({...form,personal_email:e.target.value})}/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div><label>Phone</label>
                <input className="inp" value={form.mobile} placeholder="+91 XXXXX XXXXX"
                  onChange={e=>setForm({...form,mobile:e.target.value})}/></div>
              <div><label>Designation <span style={{color:"#DC2626"}}>*</span></label>
                <select className="inp" value={form.designation} onChange={e=>setForm({...form,designation:e.target.value})}>
                  <option value="">— Select Designation —</option>
                  {desigs.map(d=><option key={d}>{d}</option>)}
                </select>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div><label>Department <span style={{color:"#DC2626"}}>*</span></label>
                <select className="inp" value={form.department_id} onChange={e=>setForm({...form,department_id:e.target.value})}>
                  <option value="">— No Department —</option>
                  {depts.map(d=><option key={d.id} value={d.id}>{d.name}</option>)}
                </select>
              </div>
              <div><label>Date of Joining <span style={{color:"#DC2626"}}>*</span></label>
                <input className="inp" type="date" value={form.date_of_joining}
                  onChange={e=>setForm({...form,date_of_joining:e.target.value})}/></div>
            </div>
            <div>
              <label>Reporting Manager <span style={{color:"#DC2626"}}>*</span></label>
              <select className="inp" value={form.reporting_to_name}
                onChange={e=>setForm({...form,reporting_to_name:e.target.value})}>
                <option value="">— None —</option>
                {users.map(u=><option key={u.employee_id} value={u.name}>{u.name} ({u.employee_id})</option>)}
              </select>
            </div>
            <div>
              <label>Profile Photo (for face recognition)</label>
              <div style={{display:"flex",alignItems:"center",gap:12,marginTop:4}}>
                <label style={{cursor:"pointer",display:"inline-flex",alignItems:"center",gap:6,
                  background:"var(--soft)",border:"1.5px dashed var(--accent)",borderRadius:8,
                  padding:"9px 16px",fontSize:13,color:"var(--accent)"}}>
                  📷 Choose Photo
                  <input type="file" accept="image/*" style={{display:"none"}}
                    onChange={e=>setPhoto(e.target.files[0])}/>
                </label>
                {photo&&<img src={URL.createObjectURL(photo)} alt=""
                  style={{width:52,height:52,borderRadius:"50%",objectFit:"cover",border:"2px solid var(--accent)"}}/>}
                <span style={{fontSize:12,color:"var(--muted)"}}>{photo?.name||"No file chosen"}</span>
              </div>
            </div>
            <hr className="divider"/>
            <button className="btn full" onClick={submit} style={{fontSize:15,padding:12}}>
              ✓ Add Employee
            </button>
            {msg&&<div style={{textAlign:"center",fontSize:13,
              color:msg.startsWith("✓")?"var(--ok)":msg.includes("face")?"#D97706":"var(--danger)"}}>
              {msg}
            </div>}
          </div>
        </Modal>
      )}
    </div>
  );
}

/* ── Departments Tab ────────────────────────────────────────────── */
function DeptsTab(){
  const [depts,setDepts]=useState([]);
  const [form, setForm] =useState({name:"",code:"",head_name:"",head_email:""});
  const [msg,  setMsg]  =useState("");
  const load=()=>api.get("/portal/departments").then(d=>setDepts(d.departments||[]));
  useEffect(()=>{load();},[]);
  const add=async()=>{
    if(!form.name||!form.code){setMsg("Name and code required.");return;}
    try{await api.post("/portal/departments",{...form,code:form.code.toUpperCase()});
      setMsg("Added ✓");setForm({name:"",code:"",head_name:"",head_email:""});load();}
    catch(e){setMsg(e.message);}
  };
  return(
    <div>
      <div className="card" style={{marginBottom:16}}>
        <h3 style={{fontSize:13,fontWeight:700,textTransform:"uppercase",letterSpacing:".06em",color:"var(--muted)",marginBottom:14}}>Add Department</h3>
        <div style={{display:"grid",gridTemplateColumns:"1fr 100px 1fr 1fr auto",gap:10,alignItems:"end"}}>
          <div><label>Name *</label><input className="inp" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="Engineering"/></div>
          <div><label>Code *</label><input className="inp" value={form.code} onChange={e=>setForm({...form,code:e.target.value.toUpperCase()})} placeholder="ENG"/></div>
          <div><label>Head Name</label><input className="inp" value={form.head_name} onChange={e=>setForm({...form,head_name:e.target.value})}/></div>
          <div><label>Head Email</label><input className="inp" value={form.head_email} onChange={e=>setForm({...form,head_email:e.target.value})}/></div>
          <button className="btn" style={{alignSelf:"end"}} onClick={add}>Add</button>
        </div>
        {msg&&<div style={{marginTop:8,fontSize:13,color:msg.includes("✓")?"var(--ok)":"var(--danger)"}}>{msg}</div>}
      </div>
      <div className="card">
        <table className="tbl">
          <thead><tr><th>Code</th><th>Name</th><th>Head</th><th>Staff</th><th/></tr></thead>
          <tbody>
            {depts.map(d=>(
              <tr key={d.id}>
                <td style={{fontWeight:600,color:"var(--accent)"}}>{d.code}</td>
                <td><b>{d.name}</b></td>
                <td style={{fontSize:13,color:"var(--muted)"}}>{d.head_name||"—"}</td>
                <td>{d.employee_count}</td>
                <td><button onClick={async()=>{if(!confirm(`Delete ${d.name}?`))return;
                  await api.delete(`/portal/departments/${d.id}`);load();}}
                  style={{background:"none",border:"none",cursor:"pointer",color:"#ef4444",fontSize:16}}>×</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ── Designations Tab ───────────────────────────────────────────── */
function DesigTab(){
  const [items,setItems]=useState([]);
  const [val,  setVal]  =useState("");
  const [msg,  setMsg]  =useState("");
  const load=()=>api.get("/portal/designations").then(d=>setItems(d.designations||[]));
  useEffect(()=>{load();},[]);
  const add=async()=>{
    if(!val)return;
    try{await api.post("/portal/designations",{name:val});setVal("");setMsg("Added ✓");load();}
    catch(e){setMsg(e.message);}
  };
  return(
    <div>
      <div className="card" style={{marginBottom:16}}>
        <h3 style={{fontSize:13,fontWeight:700,textTransform:"uppercase",letterSpacing:".06em",color:"var(--muted)",marginBottom:14}}>Add Designation</h3>
        <div style={{display:"flex",gap:10,alignItems:"end"}}>
          <div style={{flex:1}}><label>Title *</label>
            <input className="inp" value={val} onChange={e=>setVal(e.target.value)}
              onKeyDown={e=>e.key==="Enter"&&add()} placeholder="e.g. Software Engineer"/></div>
          <button className="btn" onClick={add}>Add</button>
        </div>
        {msg&&<div style={{marginTop:8,fontSize:13,color:msg.includes("✓")?"var(--ok)":"var(--danger)"}}>{msg}</div>}
      </div>
      <div className="card">
        <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
          {items.map(name=>(
            <span key={name} style={{display:"inline-flex",alignItems:"center",gap:8,
              background:"var(--soft)",border:"1px solid var(--line)",borderRadius:20,
              padding:"7px 14px",fontSize:13}}>
              {name}
              <button onClick={async()=>{await api.delete(`/portal/designations/${encodeURIComponent(name)}`);load();}}
                style={{background:"none",border:"none",cursor:"pointer",color:"#ef4444",fontSize:16}}>×</button>
            </span>
          ))}
          {!items.length&&<p style={{color:"var(--muted)",fontSize:13}}>No designations yet.</p>}
        </div>
      </div>
    </div>
  );
}

/* ── Timesheet Settings Tab ─────────────────────────────────────── */
function TSSettingsTab(){
  const [sub,      setSub]     = useState("clients");
  const [clients,  setClients] = useState([]);
  const [projects, setProjects]= useState([]);
  const [jobs,     setJobs]    = useState([]);
  const [cForm,    setCForm]   = useState({name:"",code:""});
  const [pForm,    setPForm]   = useState({client_id:"",name:"",code:""});
  const [jName,    setJName]   = useState("");
  const [msgs,     setMsgs]    = useState({c:"",p:"",j:""});
  const set=(k,v)=>setMsgs(m=>({...m,[k]:v}));
  const loadAll=()=>{
    api.get("/portal/timesheet/clients").then(d=>setClients(d.clients||[]));
    api.get("/portal/timesheet/projects").then(d=>setProjects(d.projects||[]));
    api.get("/portal/timesheet/jobs").then(d=>setJobs(d.jobs||[]));
  };
  useEffect(()=>{loadAll();},[]);

  const Pill=({item,onDel})=>(
    <span style={{display:"inline-flex",alignItems:"center",gap:8,background:"var(--soft)",
      border:"1px solid var(--line)",borderRadius:20,padding:"7px 14px",fontSize:13}}>
      <b>{item.name}</b>{item.code&&<span style={{color:"var(--muted)",fontSize:11}}>{item.code}</span>}
      {item.client_name&&<span style={{color:"var(--muted)",fontSize:11}}>({item.client_name})</span>}
      <button onClick={onDel} style={{background:"none",border:"none",cursor:"pointer",color:"#ef4444",fontSize:16}}>×</button>
    </span>
  );

  return(
    <div>
      <div style={{display:"inline-flex",background:"var(--soft)",borderRadius:10,padding:4,gap:4,marginBottom:18}}>
        {["clients","projects","jobs"].map(s=>(
          <button key={s} onClick={()=>setSub(s)}
            style={{border:"none",borderRadius:7,padding:"7px 18px",fontSize:13,fontWeight:600,cursor:"pointer",
              background:sub===s?"var(--accent)":"transparent",color:sub===s?"#fff":"var(--muted)"}}>
            {s.charAt(0).toUpperCase()+s.slice(1)}
          </button>
        ))}
      </div>

      {sub==="clients"&&(
        <>
          <div className="card" style={{marginBottom:16}}>
            <h3 style={{fontSize:13,fontWeight:700,textTransform:"uppercase",letterSpacing:".06em",color:"var(--muted)",marginBottom:14}}>Add Client</h3>
            <div style={{display:"flex",gap:10,alignItems:"end"}}>
              <div style={{flex:1}}><label>Name *</label><input className="inp" value={cForm.name} onChange={e=>setCForm({...cForm,name:e.target.value})} placeholder="Acme Corp"/></div>
              <div style={{width:100}}><label>Code *</label><input className="inp" value={cForm.code} onChange={e=>setCForm({...cForm,code:e.target.value.toUpperCase()})} placeholder="ACME"/></div>
              <button className="btn" onClick={async()=>{try{await api.post("/portal/timesheet/clients",cForm);setCForm({name:"",code:""});set("c","Added ✓");loadAll();}catch(e){set("c",e.message);}}}>Add</button>
            </div>
            {msgs.c&&<div style={{marginTop:8,fontSize:13,color:msgs.c.includes("✓")?"var(--ok)":"var(--danger)"}}>{msgs.c}</div>}
          </div>
          <div className="card"><div style={{display:"flex",flexWrap:"wrap",gap:8}}>
            {clients.map(c=><Pill key={c.id} item={c} onDel={async()=>{await api.delete(`/portal/timesheet/clients/${c.id}`);loadAll();}}/>)}
            {!clients.length&&<p style={{color:"var(--muted)",fontSize:13}}>No clients yet.</p>}
          </div></div>
        </>
      )}

      {sub==="projects"&&(
        <>
          <div className="card" style={{marginBottom:16}}>
            <h3 style={{fontSize:13,fontWeight:700,textTransform:"uppercase",letterSpacing:".06em",color:"var(--muted)",marginBottom:14}}>Add Project</h3>
            <div style={{display:"grid",gridTemplateColumns:"1fr 100px 1fr auto",gap:10,alignItems:"end"}}>
              <div><label>Client *</label>
                <select className="inp" value={pForm.client_id} onChange={e=>setPForm({...pForm,client_id:e.target.value})}>
                  <option value="">— Select —</option>
                  {clients.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              </div>
              <div><label>Code *</label><input className="inp" value={pForm.code} onChange={e=>setPForm({...pForm,code:e.target.value.toUpperCase()})} placeholder="PRJ1"/></div>
              <div><label>Name *</label><input className="inp" value={pForm.name} onChange={e=>setPForm({...pForm,name:e.target.value})} placeholder="Project name"/></div>
              <button className="btn" onClick={async()=>{try{await api.post("/portal/timesheet/projects",{...pForm,client_id:parseInt(pForm.client_id)});setPForm({client_id:"",name:"",code:""});set("p","Added ✓");loadAll();}catch(e){set("p",e.message);}}}>Add</button>
            </div>
            {msgs.p&&<div style={{marginTop:8,fontSize:13,color:msgs.p.includes("✓")?"var(--ok)":"var(--danger)"}}>{msgs.p}</div>}
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {Object.entries(projects.reduce((a,p)=>{(a[p.client_name]=a[p.client_name]||[]).push(p);return a;},{}))
              .map(([client,projs])=>(
                <div key={client} className="card">
                  <div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",color:"var(--muted)",letterSpacing:".06em",marginBottom:10}}>{client}</div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                    {projs.map(p=><Pill key={p.id} item={p} onDel={async()=>{await api.delete(`/portal/timesheet/projects/${p.id}`);loadAll();}}/>)}
                  </div>
                </div>
              ))}
            {!projects.length&&<div className="card"><p style={{color:"var(--muted)",fontSize:13}}>No projects yet.</p></div>}
          </div>
        </>
      )}

      {sub==="jobs"&&(
        <>
          <div className="card" style={{marginBottom:16}}>
            <h3 style={{fontSize:13,fontWeight:700,textTransform:"uppercase",letterSpacing:".06em",color:"var(--muted)",marginBottom:14}}>Add Job</h3>
            <div style={{display:"flex",gap:10,alignItems:"end"}}>
              <div style={{flex:1}}><label>Job Title *</label>
                <input className="inp" value={jName} onChange={e=>setJName(e.target.value)} placeholder="Development, Testing, Design…"/></div>
              <button className="btn" onClick={async()=>{try{await api.post("/portal/timesheet/jobs",{name:jName});setJName("");set("j","Added ✓");loadAll();}catch(e){set("j",e.message);}}}>Add</button>
            </div>
            {msgs.j&&<div style={{marginTop:8,fontSize:13,color:msgs.j.includes("✓")?"var(--ok)":"var(--danger)"}}>{msgs.j}</div>}
          </div>
          <div className="card"><div style={{display:"flex",flexWrap:"wrap",gap:8}}>
            {jobs.map(j=><Pill key={j.id} item={j} onDel={async()=>{await api.delete(`/portal/timesheet/jobs/${j.id}`);loadAll();}}/>)}
            {!jobs.length&&<p style={{color:"var(--muted)",fontSize:13}}>No jobs yet.</p>}
          </div></div>
        </>
      )}
    </div>
  );
}

/* ── Role Access Tab ────────────────────────────────────────────── */
function PermsTab(){
  const [perms,setPerms]=useState(null);
  const [msg,  setMsg]  =useState("");
  useEffect(()=>{ api.get("/portal/admin/permissions").then(d=>setPerms(d)).catch(()=>{}); },[]);
  const FEAT={checkin:"Check In/Out",attendance:"Attendance",leaves:"Leaves",
    history:"History",direct_call:"Direct Call",team:"Team",
    timesheet:"Timesheet (fill)",timesheet_admin:"Timesheet Settings"};
  const ROLE={admin:"Admin",hr:"HR",team_member:"Team Member",manager:"Manager"};
  if(!perms) return <div className="loading">Loading…</div>;
  return(
    <div>
      <div style={{overflowX:"auto"}}>
        <table className="tbl">
          <thead><tr>
            <th>Feature</th>
            {perms.roles.map(r=><th key={r} style={{textAlign:"center"}}>{ROLE[r]||r}</th>)}
          </tr></thead>
          <tbody>
            {perms.features.map(f=>(
              <tr key={f}>
                <td>{FEAT[f]||f}</td>
                {perms.roles.map(r=>(
                  <td key={r} style={{textAlign:"center"}}>
                    {r==="admin"
                      ? <span style={{color:"var(--muted)"}}>✓</span>
                      : <input type="checkbox" checked={!!(perms.perms.roles?.[r]?.[f])}
                          onChange={e=>{
                            const np=JSON.parse(JSON.stringify(perms));
                            np.perms.roles[r]=np.perms.roles[r]||{};
                            np.perms.roles[r][f]=e.target.checked;
                            setPerms(np);
                          }}/>}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{marginTop:16,display:"flex",gap:12,alignItems:"center"}}>
        <button className="btn" onClick={async()=>{
          try{await api.put("/portal/admin/permissions",{perms:perms.perms});setMsg("Saved ✓");}
          catch(e){setMsg(e.message);}
        }}>Save changes</button>
        {msg&&<span style={{fontSize:13,color:msg.includes("✓")?"var(--ok)":"var(--danger)"}}>{msg}</span>}
      </div>
    </div>
  );
}

/* ── Main Admin page ────────────────────────────────────────────── */
const TABS=[
  {id:"users",            label:"Users",       admin:true     },
  {id:"perms",            label:"Role access", admin:true     },
  {id:"depts",            label:"Departments", admin:true     },
  {id:"desigs",           label:"Designations",admin:true     },
  {id:"timesheet-settings",label:"⏱ Timesheet",ts_admin:true },
];

export default function Admin(){
  const {me}=useAuth();
  const isAdmin   = me?.role==="admin";
  const isTsAdmin = !!(me?.features?.timesheet_admin)||me?.role==="hr";
  const [tab,setTab]=useState(isAdmin?"users":"timesheet-settings");

  const visibleTabs=TABS.filter(t=>{
    if(t.admin&&!isAdmin)return false;
    if(t.ts_admin&&!isTsAdmin)return false;
    return true;
  });

  return(
    <div>
      <h2 className="page-title">Admin</h2>
      <p className="page-sub">Users, roles, and feature access.</p>
      <div className="tabs" style={{marginTop:16}}>
        {visibleTabs.map(t=>(
          <button key={t.id} className={`tab ${tab===t.id?"active":""}`}
            onClick={()=>setTab(t.id)}>{t.label}</button>
        ))}
      </div>
      <div className="card">
        {tab==="users"  &&<UsersTab/>}
        {tab==="perms"  &&<PermsTab/>}
        {tab==="depts"  &&<DeptsTab/>}
        {tab==="desigs" &&<DesigTab/>}
        {tab==="timesheet-settings"&&<TSSettingsTab/>}
      </div>
    </div>
  );
}
